import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaundryOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M25.75 2H6.25A3.13 3.13 0 0 0 3 5v23a2.15 2.15 0 0 0 2 2h22a2.15 2.15 0 0 0 2-2V5a3.13 3.13 0 0 0-3.25-3M27 28H5V5a1.16 1.16 0 0 1 1.25-1h19.5A1.16 1.16 0 0 1 27 5z" />
    <path d="M16 9a9 9 0 0 0-9 9 9 9 0 0 0 .13 1.5v.05a9 9 0 0 0 17.71-.07.2.2 0 0 0 0-.05A8.6 8.6 0 0 0 25 18a9 9 0 0 0-9-9m0 16a7 7 0 0 1-6.71-5A3.73 3.73 0 0 1 12 19a7.1 7.1 0 0 1 3.49 1.36A8.74 8.74 0 0 0 20 22a6.8 6.8 0 0 0 1.91-.27A7 7 0 0 1 16 25m7-6.23A3.63 3.63 0 0 1 20 20a7.1 7.1 0 0 1-3.49-1.36A8.74 8.74 0 0 0 12 17a6.07 6.07 0 0 0-3 .72A7 7 0 0 1 23 18zM8 8h4a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconLaundryOutlineSVG);
ForwardRef.displayName = "IconLaundryOutline";
export { ForwardRef as IconLaundryOutline };
